import createTableStore from "ds/components/Table/store/useTableStore";

import {
  INTENT_PROJECT_RESOURCES_COLUMN_CONFIG,
  INTENT_PROJECT_RESOURCES_TABLE_STORAGE_KEY,
} from "./constants";

const useIntentProjectResourcesTableStore = createTableStore({
  storageKey: INTENT_PROJECT_RESOURCES_TABLE_STORAGE_KEY,
  config: INTENT_PROJECT_RESOURCES_COLUMN_CONFIG,
  version: 2,
});

export default useIntentProjectResourcesTableStore;
